import React from "react";
import {styled} from "@mui/styles";
import {Box, Grid, LinearProgress, linearProgressClasses, Typography} from "@mui/material";


const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
    height: 10,
    borderRadius: 5,
    // [`&.${linearProgressClasses.colorPrimary}`]: {
    //     backgroundColor: `yellow`
    // },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: `28px`,
        backgroundColor: `linear-gradient(90deg, #47B5F9 0%, #2283D2 100%)`
    }
}));

interface Props {
    withLabel: boolean,
    value: number,
}

export const ProgressBarWithLabel: React.FC<Props> = ({
                                                          withLabel,
                                                          value,
                                                      }) => {
    return (
        <Grid container columns={16}>
            <Grid item xs>
                <Box sx={{
                    display: `flex`,
                    alignItems: `center`,
                    height: `100%`,
                    width: `100%`,
                }}>
                    <BorderLinearProgress variant={value === 0 ? "indeterminate" : "determinate"} value={value} sx={{
                        height: `16px`,
                        borderRadius: `28px`,
                        width: `100%`,
                        backgroundColor: `linear-gradient(90deg, #47B5F9 0%, #2283D2 100%);`
                    }}/>
                </Box>
            </Grid>
            {
                withLabel &&
                <Grid item xs={2}>
                    <Typography textAlign={`end`}>
                        {value}%
                    </Typography>
                </Grid>
            }
        </Grid>
    )
}
